<template>
  <div class="contract-requests container container_30">
    <searcher @compose-filters="loadFilteredContracts"/>
    <md-table class="contract-requests__table">
      <template v-if="list.length">
        <md-table-row class="contract-requests_row">
          <md-table-head>{{ i18n.cont_counterparty() }}</md-table-head>
          <md-table-head>{{ i18n.lbl_type() }}</md-table-head>
          <md-table-head>{{ i18n.com_state_as_status() }}</md-table-head>
          <md-table-head>{{ i18n.cont_contract_number() }}</md-table-head>
          <md-table-head>{{ i18n.lbl_start_date() }}</md-table-head>
          <md-table-head>{{ i18n.lbl_end_date() }}</md-table-head>
          <md-table-head><!--Button--></md-table-head>
        </md-table-row>
        <template v-for="(item, i) in list">
          <md-table-row v-if="item.state !== REQUEST_STATES_STR.approved" class="contract-requests__row" :key="i">
            <md-table-cell class="contract-requests__table-cell counterparty-cell">
              <company-name-getter :id="item.requestor" />
            </md-table-cell>
            <md-table-cell class="contract-requests__table-cell counterparty-cell">{{ getContractType(item.requestor) }}</md-table-cell>
            <md-table-cell class="contract-requests__table-cell contract-request-state-cell">{{ item.state === REQUEST_STATES_STR.permanentlyRejected ? REQUEST_STATES_STR.rejected : item.state }}</md-table-cell>
            <md-table-cell class="contract-requests__table-cell contract-number-cell">{{ item.contractNumber }}</md-table-cell>
            <md-table-cell class="contract-requests__table-cell">{{ i18n.d(item.startTime) }}</md-table-cell>
            <md-table-cell class="contract-requests__table-cell">{{ i18n.d(item.endTime) }}</md-table-cell>
            <md-table-cell class="contract-requests__table-cell">
              <md-button class="contract-requests__view-details-btn md-icon-button"
                        @click="openDetails(item.id)">
                <md-icon>keyboard_arrow_right</md-icon>
              </md-button>
            </md-table-cell>

          </md-table-row>
        </template>
         <md-table-row v-if="!isLoaded">
            <md-table-cell colspan="7">
                <div class="contract-requests__btn-outer">
                  <md-button @click="more" :disabled="isLoading" class="md-primary">{{ i18n.lbl_view_more() }}</md-button>
                </div>
            </md-table-cell>
         </md-table-row>
      </template>
      <template v-else>
        <div class="contract-requests__no-contracts">
          <md-icon class="md-size-4x">trending_up</md-icon>
          <h2>{{ i18n.cont_no_contract_requests() }}</h2>
          <p>{{ i18n.cont_no_contract_requests_desc() }}</p>
        </div>
      </template>
    </md-table>
  </div>
</template>

<script>
import Searcher from '../Contracts.Searcher'
import get from 'lodash/get'

import { mapGetters, mapActions } from 'vuex'
import { i18n } from '@js/i18n'
import { documentTypes,
  ASSET_POLICIES_VERBOSE,
  CONTRACTS_DETAILS_TYPES,
  REQUEST_STATES_STR } from '@const'
import { usersService } from '@api/users.service'
import { vuexTypes } from '@vuex/types'
import CompanyNameGetter from '@vue/app/common/CompanyNameGetter'

import { EventDispatcher } from '@js/events/event_dispatcher'

export default {
  components: { Searcher,
    CompanyNameGetter },
  data: _ => ({
    i18n,
    documentTypes,
    isLoading: false,
    ASSET_POLICIES_VERBOSE,
    REQUEST_STATES_STR,
    filters: {
      counterparty: '',
      contractNumber: '',
      startTime: '',
      endTime: ''
    }
  }),

  async created () {
    await this.loadFilteredContracts()
  },

  computed: {
    ...mapGetters([
      vuexTypes.accountId,
      vuexTypes.contractCreationRequests
    ]),
    list () {
      return get(this.contractCreationRequests, 'records', [])
    },
    isLoaded () {
      return get(this.contractCreationRequests, 'isLoaded')
    }
  },

  methods: {
    ...mapActions({
      loadList: vuexTypes.GET_USER_CONTRACT_CREATION_REQUESTS,
      loadNext: vuexTypes.NEXT_USER_CONTRACT_CREATION_REQUESTS
    }),
    async more () {
      this.isLoading = true
      try {
        await this.loadNext()
      } catch (e) {
        console.error(e)
        EventDispatcher.dispatchShowErrorEvent(i18n.th_failed_to_load_tx())
      }
      this.isLoading = false
    },
    getContractType (contractorId) {
      return contractorId === this.accountId ? i18n.cont_type_outgoing() : i18n.cont_type_incoming()
    },

    async getCounterpartyName (id) {
      const counterpartyData = (await usersService.loadUser(id)).kycData()
      return get(counterpartyData, 'company_name', '')
    },
    openDetails (id) {
      this.$emit('open-details', {id: id, type: CONTRACTS_DETAILS_TYPES.requests})
    },
    loadFilteredContracts (filters) {
      if (filters) {
        this.filters.counterparty = filters.counterparty
        this.filters.contractNumber = filters.contractNumber
        this.filters.startTime = filters.startDate
        this.filters.endTime = filters.endDate
      }
      return this.loadList(this.filters)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~scss/mixins";
  @import "~scss/variables";

  .contract-requests {
    background: $default-white;
  }

  .contract-requests__table {
    margin-top: 1.5rem;
    // md-card styles
    border-radius: 2px;
    box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, 0.08);
  }

  .contract-requests__view-details-btn {
    float: right;
  }

  .contract-requests__no-contracts {
    margin: 1rem auto;
    text-align: center;
  }

  .contract-requests__btn-outer {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/contracts/index/requests/Contracts.RequestsList.vue